import moment from 'moment';
import PropTypes from 'prop-types';
import Day from './day';
import {useTime} from '../context/time-context';
import isHoliday from '../utils/holidays';
import {dayIsBooked, getWeekAhead, retrieveSchedulableWindows} from '../utils/scheduled-window';
import {useSelector} from 'react-redux';

const getStartingDay = (selectedDay, minDate) => {
  const minimumDate = moment(minDate);
  const weeksDiff = selectedDay.clone().startOf('day').diff(minimumDate.clone().startOf('day'), 'week');
  return minimumDate.clone().add(weeksDiff, 'week');
};

const DayPicker = ({schedulableWindows, selectDay, selectedDay}) => {
  const scheduler = useSelector((state) => state.scheduler);
  const {minimumDay, maximumDay, fetchingWindows} = useTime();
  const startingDay = getStartingDay(selectedDay, minimumDay);

  const days = getWeekAhead(startingDay);

  const dayIsSelected = (chosenDay) => chosenDay.isSame(scheduler?.selectedDay, 'day');

  const dayIsDisabled = (chosenDay) =>
    fetchingWindows ||
    (maximumDay && maximumDay.isBefore(moment(chosenDay))) ||
    !retrieveSchedulableWindows(schedulableWindows, chosenDay).length ||
    dayIsBooked(retrieveSchedulableWindows(schedulableWindows, chosenDay));

  return (
    <div className={styles.container}>
      {days.map((d, i) => {
        const isSelected = dayIsSelected(d);
        const isDisabled = dayIsDisabled(d);
        return (
          <div
            className={styles.dayWrapper(isSelected, isDisabled)}
            key={`${d.toISOString()}`}
            onClick={() => (isDisabled ? null : selectDay(d))}>
            <div>
              {dayIsBooked(retrieveSchedulableWindows(schedulableWindows, d)) && (
                <p className={styles.holiday}>Booked</p>
              )}
              {isHoliday(d) && <p className={styles.holiday}>Holiday!</p>}
            </div>

            <p className={styles.dayOfWeek}>{d.format('ddd')}</p>

            <Day day={d} disabled={isDisabled} key={`${d.day()}${i}`} onClick={selectDay} selectedDay={selectedDay} />
          </div>
        );
      })}
    </div>
  );
};

const styles = {
  container: 'flex items-center self-stretch justify-around w-full m-0',
  dayWrapper: (isSelected, isDisabled) =>
    `flex flex-col justify-center items-center w-[80px] p-1 ${
      isDisabled ? 'cursor-not-allowed disabled-day' : 'cursor-pointer available-day'
    } ${isSelected ? 'selected-day' : ''} hover:border hover:border-light-gray hover:rounded-md`,
  holiday: 'text-primary text-sm m-0 text-center w-full',
  dayOfWeek: 'text-sm mb-2 text-black',
};

DayPicker.propTypes = {
  isLoading: PropTypes.bool,
  minDate: PropTypes.instanceOf(moment),
  maxDate: PropTypes.instanceOf(moment),
  schedulableWindows: PropTypes.object,
  selectDay: PropTypes.func,
  selectedDay: PropTypes.instanceOf(moment),
};

DayPicker.defaultProps = {
  isLoading: false,
  schedulableWindows: {},
  selectDay: () => {},
};

export default DayPicker;
